import { Box, Button, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, InputAdornment, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, Switch, TextField, Tooltip, Typography } from "@mui/material";
import useGlobal from "./useGlobal";
import { useEffect, useState } from "react";
import './shop.css'
import { isMobile } from "react-device-detect";
import { AddBox, Cancel, Close, Delete, Edit, HdrPlus, Height, PlusOne, Search } from "@mui/icons-material";
import { UpdateItem } from "./updateItem";



export function Shop(){
    const [axios,setAxios] = useGlobal('axios')
    const [loggedin,setLoggedin] = useGlobal('loggedin')
    const [cats,setCats] = useState([])
    const [foruser,setForuser] = useGlobal('foruser',false)
    const [catfilter,setCatfilter] = useState([])
    const [budgetfilter,setBudgetfilter] = useState(false)
    const [items,setItems] = useState([])
    const [cart,setCart] = useGlobal('cart')
    const [curbudget,setCurbudget] = useGlobal('curbudget',0)
    const [addto,setAddto] = useState(false)
    const [fullviewitem,setFullviewitem] = useState(false)
    const [permissions,setPermissions] = useGlobal('permissions',[])
    const [editItem,setEditItem] = useState(false)
    const [searchterm,setSearchterm] = useState('')
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        if (axios && loggedin) {
            console.log('get Items')
            getData()
        }
    },[axios,loggedin,foruser])

    const getData = () => {
        const params = {foruser:foruser}
        setLoading(true)
        axios.get('shop',{params}).then(data => {
            setItems(data.data.data)
            if (editItem) {
                setEditItem(data.data.data.find( item => item._id == editItem._id))
            }
        }).catch(e => console.log(e)).finally(() => setLoading(false))
        axios.get('cats').then(data => {setCats(data.data)})
    }


    const orderitem = (item) => {
        setFullviewitem(false)
        setAddto(false)
        if (item){
            let count = item?.count || 1
            let tmpcart = cart
            for (let i = 0; i < count; i++) {
                    tmpcart = [...tmpcart,item]
            }
            setCart(tmpcart)
        }
    }

    const afterupdate = (val) => {
        setEditItem(false)
        if (val) {
            getData()
        }
    }

 

    return (
        <Container fixed maxWidth='lg' className='main'>
        <Box sx={{display:'flex',justifyContent:'center',marginTop:'10px'}}>
            <TextField
                size="small"
                placeholder="Suche…"
                value={searchterm}
                onChange={e => setSearchterm(e.target.value)}
                variant="outlined"
                sx={{width:'100%',maxWidth:'380px'}}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search fontSize="small" sx={{opacity:0.6}}/>
                        </InputAdornment>
                    ),
                    endAdornment: searchterm ? (
                        <InputAdornment position="end">
                            <Close fontSize="small" sx={{cursor:'pointer',opacity:0.6,'&:hover':{opacity:1}}} onClick={() => setSearchterm('')}/>
                        </InputAdornment>
                    ) : null,
                }}
            />
        </Box>
        <Box sx={{width:'100%',marginTop:'10px'}}>
            {!!(cats && cats.length) &&
                <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="space-evenly" sx={{rowGap:1}}>
                    {cats.map((c,i) =>
                        <Chip key={i+c} label={c} clickable
                            color={catfilter.includes(c) ? 'primary' : 'default'}
                            variant={catfilter.includes(c) ? 'filled' : 'outlined'}
                            onClick={e => setCatfilter([...new Set([...catfilter,c])])}
                            onDelete={e => setCatfilter(catfilter.filter(i => i !== c))}
                            deleteIcon={catfilter.includes(c) ? <Close /> : <></>}
                        />
                    )}
        <FormControlLabel control={<Switch checked={budgetfilter} onChange={e => setBudgetfilter(e.target.checked)} />} label="Nur, was ich mir leisten kann" />
                </Stack>
            }
        </Box>
        <Divider/>
            {permissions.includes('shopmanager') && 
            <Paper className={isMobile ? 'item_mobile' : 'item'} style={{justifyContent:'center',alignItems:'center'}} >
                <AddBox style={{fontSize: 60}} onClick={e => setEditItem({name:'',beschreibung:'',varianten:'',preis:0})}/>
            </Paper>
            }
            {(() => {
                if (loading) {
                    return (
                        <Box sx={{width:'100%', display:'flex', justifyContent:'center', padding:'40px 0'}}>
                            <CircularProgress/>
                        </Box>
                    );
                }
                const filtered = (items || [])
                    .filter(it => (it.Preis <= curbudget) || !budgetfilter)
                    .filter(it => catfilter.includes(it?.kategorie) || !catfilter.length)
                    .filter(it => {
                        const q = searchterm.trim().toLowerCase();
                        if (!q) return true;
                        return (it.name || '').toLowerCase().includes(q)
                            || (it.beschreibung || '').toLowerCase().includes(q)
                            || (it.kategorie || '').toLowerCase().includes(q);
                    });
                if (filtered.length === 0) {
                    return (
                        <Box sx={{width:'100%', display:'flex', justifyContent:'center', padding:'40px 0'}}>
                            <Typography variant="body1" color="text.secondary">
                                Kein Artikel entspricht den gesetzten Filtern.
                            </Typography>
                        </Box>
                    );
                }
                return filtered.map(item =>
                    <Paper key={item._id} className={isMobile ? 'item_mobile' : 'item'} sx={{filter:item.deaktiviert ? 'brightness(0.5)': 'brightness(1)' }}>
                        <Typography className="item-title" title={item.name}>{item.name}</Typography>
                        <img src={'https://shop.rdheinsberg.de/api/bild/small_'+item.bild} onClick={e => setFullviewitem(item)}
                            alt='bild folgt' className={isMobile ? 'img_mobile' : 'img_browser'}/>
                        <Button variant="contained" sx={isMobile ? {padding:'2px'} : {padding:'5px'}} onClick={e => setAddto(item)} disabled={(item.Preis > curbudget) || item.deaktiviert }>
                            <Box className='bestellbuttonmitpreis'>{item?.Preis && <Box className='preis'>{parseFloat(item.Preis).toFixed(2)}€{item.relativpreis && <Tooltip title="Preis wird anteilig zu deinem Vollzeitäquivalent berechnet"><span onClick={e => e.stopPropagation()} style={{fontSize:'0.7em',opacity:0.7,marginLeft:'2px'}}>(r)</span></Tooltip>}</Box>}    <Box>bestellen</Box></Box>
                        </Button>
                    </Paper>
                );
            })()}
        <FullView item={fullviewitem} bookme={e => orderitem(e)} curbudget={curbudget} editme={setEditItem}/>
        <VariantChooser item={addto} onchoose={e => orderitem(e)}/>
        {permissions.includes('shopmanager') && <UpdateItem closeme={e => afterupdate(e)} item={editItem} />}
        </Container>
    )
}


function FullView({item,bookme,editme,curbudget}) {
    const [variante,setVariante] = useState(false)
    const [permissions,setPermissions] = useGlobal('permissions',[])
    const [count,setCount] = useState(1)
    const [customize,setCustomize] = useState('')
    const [custom_color,setCustom_color] = useState('')
    useEffect(() => {
        if (!item) {
            setVariante(false)
            setCount(1)
            setCustomize('')
            setCustom_color('')
        }
        if (item) console.log(item?.varianten,variante,!!item?.varianten.length)
    },[item,variante])


    return (
        <Dialog open={!!item} onClose={e => bookme(false)} style={{backdropFilter:'blur(3px)'}} PaperProps={{ style: {backgroundColor:'#deecffe3',}}}>
            {item && <>
            <DialogTitle>{item.name}</DialogTitle>
            <DialogContent>
            <img src={'https://shop.rdheinsberg.de/api/bild/big_'+item.bild} alt='bild folgt' style={{width:'90%',height:'auto'}}/>
            {permissions.includes('shopmanager') && 
                <Edit onClick={e => editme(item)}/>
            }
            <Container>
                <Typography variant="body2" color="text.secondary" sx={{marginTop:1, whiteSpace:'pre-line'}}>
                    {item.beschreibung}
                </Typography>
            </Container>
                {item.customizeable && 
                    <Box sx={{display:'flex', gap:1, marginTop:'5px'}}>
                        <TextField type="text" value={customize} onChange={e => setCustomize(e.target.value)} label='Personalisierung' sx={{width:'70%'}}/>
                        {item.custom_colorable && !!item.custom_colorable.length &&
                            <FormControl sx={{width:'30%'}}>
                                <InputLabel>Farbe</InputLabel>
                                <Select value={custom_color} label="Farbe" onChange={e => setCustom_color(e.target.value)}>
                                    {item.custom_colorable.map((color,i) => 
                                        <MenuItem key={i+color} value={color}>{color}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        }
                    </Box>
                }

            </DialogContent>
            <DialogActions sx={{ flexDirection: 'column', gap: 2, alignItems: 'stretch' }}>
                <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
                    {!!(item?.varianten && item.varianten.length) && 
                    <FormControl fullWidth>
                        <InputLabel>Variante</InputLabel>
                        <Select value={variante} label="Variante" onChange={e => setVariante(e.target.value)}>
                            {item.varianten.map((v,i) => 
                                <MenuItem value={v}>{v}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    }
                    {permissions.includes('shopmanager') && 
                        <TextField type="number" value={count} onChange={e => setCount(e.target.value)} label='Anzahl'/>
                    }
                </Box>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', width: '100%' }}>
                    <Button variant="outlined" onClick={e => bookme(false)} sx={{minWidth:'100px'}}>abbrechen</Button>
                    <Button variant="contained" onClick={e => bookme({...item,variante:variante,count:count,customize:customize,custom_color:custom_color})} 
                            disabled={!((item?.varianten.length && variante) || !item?.varianten.length) || (item.Preis > curbudget && !permissions.includes('shopmanager'))}
                            sx={{ minWidth: '100px', marginRight:'5px'}}>bestellen</Button>
                </Box>
            </DialogActions>

            </>}

        </Dialog>
    )
}

function VariantChooser({item,onchoose}) {
    const [selvar,setSelvar] = useState(false)
    const [open,setOpen] = useState(false)
    const [customizeable,setCustomizeable] = useState(false)
    const [variant,setVariant] = useState(false)
    const [customize,setCustomize] = useState('')
    const [custom_color,setCustom_color] = useState('')


    useEffect(() => {
        if (!item) {
            console.log('noitem')
            setOpen(false)
            setSelvar(false)
            setVariant(false)
            setCustomizeable(false)
            setCustom_color('')
            setCustomize('')
        } else {
            console.log(item)
            if ((item && item?.varianten && item.varianten.length) || (item && item?.customizeable)) {
                if (item?.varianten && item.varianten.length) {
                    setVariant(true)
                }
                if (item?.customizeable) {
                    setCustomizeable(true)
                }   
                setOpen(true)
            } else {
                onchoose(item)
            }
        }
    },[item])

    

    return (
        <Dialog open={open} PaperProps={{style:{padding:'20px'},className:'userinfodialog'}} style={{backdropFilter:'blur(3px)'}} PaperProps={{ style: {backgroundColor:'#deecffe3',}}}>
            <DialogTitle>{item.name}</DialogTitle>
            <DialogContent>
                {variant && item?.varianten && !!item.varianten.length &&
                <FormControl>
                    <FormLabel>Welche Variante?</FormLabel>
                    <RadioGroup value={selvar} onChange={e => setSelvar(e.target.value)}>
                        {item && item.varianten && item.varianten.map((v,i) => 
                            <FormControlLabel value={v} control={<Radio/>} label={v}/>                        
                        )}
                    </RadioGroup>
                </FormControl>
                }
                {customizeable && item?.customizeable &&
                    <Box sx={{display:'flex', flexDirection:'column', gap:2}}>
                        <TextField fullWidth type="text" value={customize} onChange={e => setCustomize(e.target.value)} label='Personalisierung'/>
                        {item?.custom_colorable && !!item.custom_colorable.length &&
                            <FormControl fullWidth>
                                <InputLabel>Personalisierung Farbe</InputLabel>
                                <Select
                                    value={custom_color}
                                    onChange={e => setCustom_color(e.target.value)}
                                    label="Personalisierung Farbe"
                                >
                                    {item.custom_colorable.map((color, i) => (
                                        <MenuItem key={i} value={color}>{color}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        }
                    </Box>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={e => onchoose(false)} sx={{ minWidth: '100px' }}>abbrechen</Button>
                <Button variant="contained" disabled={(variant && !selvar) || (customizeable && !customize)} 
                        onClick={e => onchoose({...item,variante:selvar,customize:customize,custom_color:custom_color})}
                        sx={{ minWidth: '100px' }}>bestellen</Button>
            </DialogActions>

        </Dialog>
    )
    

}

